// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationCallRecord.yaml
// Generated: 2026-09-25T09:41:42.403Z
// </auto-generated>

import { ReadOnlyEntityService } from '@/lib/EntityService';
import { IntegrationCallRecord } from '@/types/integration/IntegrationCallRecord';

/**
 * IntegrationCallRecord Service (Read-Only)
 * Query operations for IntegrationCallRecord via the ABP API.
 */
export const integrationCallRecordService = new ReadOnlyEntityService<IntegrationCallRecord>(
  '/api/integration/integrationcallrecord',
  'IntegrationCallRecord',
);
